import { FallbackProps } from '@thriveglobal/thrive-web-errors'
import {
    ErrorScreen,
    ErrorScreenVariant
} from '@thriveglobal/thrive-web-leafkit'

export const PageFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
    return <ErrorScreen variant={ErrorScreenVariant.General} />
}
